// extracted by mini-css-extract-plugin
module.exports = {"text":"TextFacet_text__uZBQl"};